import api from './index';

export default {
  getAll(params = {}) {
    return api.get('/routes', { params });
  },
  getOne(id) {
    return api.get(`/routes/${id}`);
  },
  getAssignments(id) {
    return api.get(`/routes/${id}/assignments`);
  },
  updateAssignments(id, data) {
    return api.put(`/routes/${id}/assignments`, data);
  },
  create(data) {
    return api.post('/routes', data);
  },
  update(id, data) {
    return api.put(`/routes/${id}`, data);
  },
  optimize(id) {
    return api.post(`/routes/${id}/optimize`);
  },
  createNext(id) {
    return api.post(`/routes/${id}/create-next`);
  },
  addStop(routeId, data) {
    return api.post(`/routes/${routeId}/stops`, data);
  },
  removeStop(routeId, stopId) {
    return api.delete(`/routes/${routeId}/stops/${stopId}`);
  },
  reorderStops(routeId, stopIds) {
    return api.put(`/routes/${routeId}/stops/reorder`, { stopIds });
  },
  updateStop(routeId, stopId, data) {
    return api.put(`/routes/${routeId}/stops/${stopId}`, data);
  },
  checkInStop(routeId, stopId) {
    return api.post(`/routes/${routeId}/stops/${stopId}/check-in`);
  },
  completeMyWork(routeId, stopId) {
    return api.post(`/routes/${routeId}/stops/${stopId}/complete-my-work`);
  },
  generateInvoices(id, stopIds) {
    return api.post(`/invoices/routes/${id}/generate-invoices`, stopIds ? { stopIds } : {});
  },
  delete(id) {
    return api.delete(`/routes/${id}`);
  },
};
